import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const PermissionLevelTooltip = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="PermissionLevelTooltip" className="input-tooltip">
      <span className="tooltip">
        <div className="tooltip-centered">
          <span>
            <strong>{t('stylistScreen.addStylist.permissionLevelTooltip.manager')}:</strong>{' '}
            {t('stylistScreen.addStylist.permissionLevelTooltip.text1')}
          </span>
          <span>
            <strong>{t('stylistScreen.addStylist.permissionLevelTooltip.receptionist')}:</strong>{' '}
            {t('stylistScreen.addStylist.permissionLevelTooltip.text2')}
          </span>
          <ul>
            <li>{t('stylistScreen.addStylist.permissionLevelTooltip.receptionistBullet1')}</li>
            <li>{t('stylistScreen.addStylist.permissionLevelTooltip.receptionistBullet2')}</li>
            <li>{t('stylistScreen.addStylist.permissionLevelTooltip.receptionistBullet3')}</li>
            <li>{t('stylistScreen.addStylist.permissionLevelTooltip.receptionistBullet4')}</li>
            <li>{t('stylistScreen.addStylist.permissionLevelTooltip.receptionistBullet5')}</li>
          </ul>
          <span>
            <strong>{t('stylistScreen.addStylist.permissionLevelTooltip.receptionistsOptional')}:</strong>
          </span>
          <ul>
            <li>{t('stylistScreen.addStylist.permissionLevelTooltip.recOptionalBullet1')}</li>
            <li>{t('stylistScreen.addStylist.permissionLevelTooltip.recOptionalBullet2')}</li>
            <li>{t('stylistScreen.addStylist.permissionLevelTooltip.recOptionalBullet3')}</li>
          </ul>
        </div>
      </span>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default PermissionLevelTooltip;
